import * as z from "zod/v4";

export const duplicateAutomationWithOptions = {
  name: "duplicateAutomationWithOptions" as const,
  input: z.object({
    automationId: z.string(),
    name: z.string().min(1),
    targetTeamIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    results: z.array(
      z.object({ teamId: z.string(), automationId: z.string() }),
    ),
  }),
};
